export enum UsersStatusEnum {
  ACTIVE = 1,
  INACTIVE = 0,
  BLOCKED = 2,
  DELETED = 3,
  EXPIRED = 4,
  PASSWORD_CHANGE_REQUIRED = 5,
}
